import React from 'react';
import { Badge, Group, Stack, Text } from '@mantine/core';
import { DeliveryEventVendorDetailsUpcoming, DeliveryEventStatus } from '../types';
import { getDeliveryEventColor } from '../helpers';
import DeliveryManifestDownload from './DeliveryUpcoming.manifestdownload';

export const DeliveryUpcomingManifests: React.FC<{
  event: DeliveryEventVendorDetailsUpcoming;
}> = ({ event }) => {
  const manifestPreview = event.preManifestDocument;
  const manifestFinal = event.finalManifestDocument;

  return (
    <Stack gap="xs" p="sm" bdrs="md" bd="1px solid var(--mantine-color-gray-4)">
      <Group gap="xs">
        <Text>Manifest version:</Text>
        <Text fw="bold">Preview</Text>
        <Badge
          size="sm"
          p="xs"
          color={getDeliveryEventColor(manifestPreview?.status as DeliveryEventStatus)}
          radius="md"
          variant="light"
        >
          {manifestPreview?.status || 'Not Ready'}
        </Badge>
        <DeliveryManifestDownload item={manifestPreview} preview />
      </Group>
      <Group>
        <Text>Manifest version:</Text>
        <Text fw="bold">Final</Text>
        <Badge
          size="sm"
          p="xs"
          color={getDeliveryEventColor(manifestFinal?.status as DeliveryEventStatus)}
          radius="md"
          variant="light"
        >
          {manifestFinal?.status || 'Not Ready'}
        </Badge>
        <DeliveryManifestDownload item={manifestFinal} />
      </Group>
    </Stack>
  );
};
